import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { BiMap } from 'react-icons/bi';
import { v4 as uuidv4 } from 'uuid';

const WidgetGetinTouchData = [
    {
        id: uuidv4(),
        icon: <AiOutlinePhone />,
        heading: 'Telefon',
        text: '0724.273.258',
    },

    {
        id: uuidv4(),
        icon: <AiOutlineMail />,
        heading: 'Email',
        text: 'office@reparatiiasfalt.ro',
    },

    {
        id: uuidv4(),
        icon: <BiMap />,
        heading: 'Adresă',
        text: 'Strada Bujorilor 4, Măgurele 077126',
    },
];

export default WidgetGetinTouchData;
